"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isServiceApiError = exports.ServiceApiErrorSchema = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../helpers/type_validation_helpers");
const auth_failure_1 = require("./auth_failure");
const language_codes_types_1 = require("./language_codes_types");
exports.ServiceApiErrorSchema = zod_1.z
    .object({
    correlationId: zod_1.z.string().uuid(),
    endpoint: zod_1.z.string(),
    isInvalidResponse: zod_1.z.boolean(),
    isServiceApiError: zod_1.z.literal(true),
    langPairCode: language_codes_types_1.LanguagePairCodeSchema.optional(),
    message: zod_1.z.string(),
    payload: zod_1.z.record(zod_1.z.any()).optional(),
    reason: auth_failure_1.AuthFailureReasonSchema.optional(),
    status: zod_1.z.number().optional(),
})
    .strict();
exports.isServiceApiError = type_validation_helpers_1.getTypeValidationFunction(exports.ServiceApiErrorSchema);
//# sourceMappingURL=service_api_errors.js.map